import actions from './actions'

const initialState = {
  downloads: {},
  loading: false,
}

export default function downloadsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
